import React from "react";
import { CardContent, Typography } from "@material-ui/core";
import styled from "styled-components";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { convertDateToText } from "helpers/jobDetail/stringHelper";
import { get } from "lodash";
import Progress from "./Progress";
import { useTranslation } from "react-i18next";
import { Grid, Card } from "@mui/material";

const ProgressPlan = ({ project }) => {
  const { t } = useTranslation();
  return (
    <WrapperGrid item xs={12}>
      <Card
        sx={{
          background: "rgb(255,255,255)",
          borderRadius: "20px",
          boxShadow: "unset",
          "&:hover": {
            boxShadow:
              "rgb(0 0 0 / 16%) 0px 10px 36px 0px, rgb(0 0 0 / 6%) 0px 0px 0px 1px",
          },
        }}
      >
        <CardContent>
          <Typography variant="h6" component="div" style={{ fontSize: "15px" }}>
            {t("PROJECT_PAGE.REPORT.PROCESSING")}
          </Typography>
          <DescriptionProgress project={project} />
          <Progress
            title={t("PROJECT_PAGE.REPORT.PLAN")}
            progress={get(project, "complete_plan", 0)}
            stateProgress={get(project, "complete_plan", 0)}
            color="#0eb9d9"
            isPlan
          />
          <Progress
            title={t("PROJECT_PAGE.REPORT.REALITY")}
            progress={get(project, "complete", 0)}
            stateProgress={get(project, "complete", 0)}
            color="#ffa601"
          />
          <WrapperFooter>
            <ArrowDropDownIcon />
            {t("PROJECT_PAGE.REPORT.TODAY")}: {convertDateToText(new Date())}
          </WrapperFooter>
        </CardContent>
      </Card>
    </WrapperGrid>
  );
};

const DescriptionProgress = ({ project }) => {
  const { t } = useTranslation();
  return (
    <Grid container spacing={2} style={{ marginTop: "15px" }}>
      <Grid item xs={5}>
        <WrapperContent>
          <p>{t("PROJECT_PAGE.REPORT.START")}</p>
          <p>{project?.date_start}</p>
        </WrapperContent>
      </Grid>
      <Grid item xs={2}>
        <WrapperContent style={{ color: "red" }}>
          <p>{t("PROJECT_PAGE.REPORT.PROCESSING")}</p>
          <p>
            {project?.duration} {t("PROJECT_PAGE.REPORT.PROCESSING_TITLE")}
          </p>
        </WrapperContent>
      </Grid>
      <Grid item xs={5}>
        <WrapperContent className="content-right">
          <p>{t("PROJECT_PAGE.REPORT.FINISH")}</p>
          <p>{project?.date_end}</p>
        </WrapperContent>
      </Grid>
    </Grid>
  );
};

const WrapperContent = styled.div`
  display: flex;
  flex-direction: column;
  p {
    margin: 0;
  }
  &.content-right {
    align-items: flex-end;
  }
`;
const WrapperGrid = styled(Grid)`
  margin-top: 20px;
  min-width: 300px;
  padding: 16px 16px 0px 16px !important;
  // @media (max-width: 768px) {
  //   max-width: calc(100% - 12rem);
  //   overflow: auto;
  // }
`;
const WrapperFooter = styled.div`
  display: flex;
  align-items: center;
  color: red;
  margin-top: 15px;
`;

export default ProgressPlan;
